module Meevo.Plugins.NotificationSetting {
    export class PhoneNumberVerificationController {
        static $inject = [
            "$mdDialog",
            "meevo.components.common.DataService",
            "meevo.AppSettings",
            "meevo.components.common.IdentityService",
            "meevo.components.busy.BusyService",
            "meevo.components.common.SecurityService",
            "meevo.components.modal.ModalService",
            "options",
            "$timeout",
            "$translate",
            "meevoDateFilterFilter",
            "$mdBottomSheet",
            "$rootElement",
            "requirePrivacyPolicyUrls"
        ];

        public model: Model.PhoneNumberVerification;

        constructor(
            private $mdDialog: angular.material.IDialogService,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            public identityService: Meevo.Components.Common.IIdentityService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            private securityService: Meevo.Components.Common.ISecurityService,
            public modalService: Meevo.Components.Modal.IModalService,
            public options: Meevo.Model.NotificationSetting,
            public $timeout: angular.ITimeoutService,
            public $translate: ng.translate.ITranslateService,
            public meevoDateFilter: any,
            public $mdBottomSheet: angular.material.IBottomSheetService,
            public $rootElement: angular.IRootElementService,
            public requirePrivacyPolicyUrls: boolean) {
            this.loadAddressData();
        }

        loadAddressData() {
            this.dataService.customMethodData(`api/NotificationSetting/PhoneVerification/${this.options.phoneNumberId}`, "GET", null)
                .then(result => {
                    if (result && result.data) {
                        this.model = result.data;
                    }
                });
        }

        save() {
            if (Model.Guard.isNothing(this.model.contactFirstName)
                || Model.Guard.isNothing(this.model.contactLastName)
                || Model.Guard.isNothing(this.model.address.address1)
                || Model.Guard.isNothing(this.model.address.city)
                || Model.Guard.isNothing(this.model.address.state)
                || Model.Guard.isNothing(this.model.address.zipCode)
                || Model.Guard.isNothing(this.model.address.country)
                || Model.Guard.isNothing(this.model.emailAddress)
                || Model.Guard.isNothing(this.model.webAddressUrl)
                || Model.Guard.isNothing(this.model.phoneNumber)
                || Model.Guard.isNothing(this.model.countryCode)
                || Model.Guard.isNothing(this.model.businessType)
                || (this.model.businessType !== 'SOLE_PROPRIETOR'
                    && (Model.Guard.isNothing(this.model.businessRegistrationNumber)
                        || Model.Guard.isNothing(this.model.businessRegistrationAuthority)
                        || Model.Guard.isNothing(this.model.businessRegistrationCountry)))
            ) {
                this.modalService.alert("MESSAGE_VERIFICATION_MISSING_INFO", Components.Modal.ModalTranslationModes.Translate, true);
                return;
            }

            let message: string = null;
            if (this.options.phoneVerificationStatus == null
                || this.options.phoneVerificationStatus == Model.PhoneVerificationStatusEnum.NotSubmitted) {
                message = "MESSAGE_SUBMIT_VERIFICATION"
            }
            else if (this.options.phoneVerificationStatus == Model.PhoneVerificationStatusEnum.Rejected) {
                message = "MESSAGE_RESUBMIT_VERIFICATION"
            }
            if (message != null) {
                return this.modalService
                           .confirm(message, Components.Modal.ModalTranslationModes.Translate, true)
                           .then(result => {
                               if (result) {
                                   return this.postData();
                               }
                           });
            }
        }

        postData() {
            return this.dataService
                       .customMethodData("api/NotificationSetting/PhoneVerification", "POST", this.model)
                       .then(response => {
                           if (!response || !response.data || !response.data.isSuccess) {
                               this.modalService.alert(response.data.result, Components.Modal.ModalTranslationModes.Translate);
                           }
                           this.closeModal(null);
                       });
        }

        closeModal(e): void {
            if (e) e.stopPropagation();
            this.$mdDialog.hide();
        }

    }

    angular.module("meevo.plugins.notificationSetting")
        .controller("meevo.plugins.notificationSetting.PhoneNumberVerificationController", PhoneNumberVerificationController);
}